import React from 'react'
import nodejslogo from "../../nodejs_logo.png"

const NodeJS = () => {
    return (
        <div style={{minHeight: 120}}>
            <div >
                <div className="card card-body" style={{width: 300}}>
                    <article >
                        <img  src={nodejslogo} alt=""/>
                    </article>
                    This is some placeholder content for a horizontal collapse. It's hidden by default and shown when triggered.
                </div>
            </div>
        </div>
    )
}

export default NodeJS
